import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
/*
 * The typefaces, served from Target itself rather than from Google.
 *
 * Loading them from Google's servers handed every visitor's IP address —
 * candidates' included — to Google on every page. Bundled, they come from the
 * same place as the rest of the app, and nobody else is told who is looking.
 * Only the weights the styles use; each file covers Latin, Uzbek Latin and
 * Cyrillic, and a browser fetches only the ranges a page actually shows.
 */
import '@fontsource-variable/schibsted-grotesk/wght.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/paper.css';
import './styles/auth.css';
import './styles/landing.css';
import './styles/exam.css';
/* Last, so the staff console's own look wins inside it and nowhere else. */
import './styles/console.css';
import './styles/staffroom.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
